/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { CountRequestBuilderRequestsMetadata, type CountRequestBuilder } from './count/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /contracts/mandates
 */
export interface MandatesRequestBuilder extends BaseRequestBuilder<MandatesRequestBuilder> {
    /**
     * The count property
     */
    get count(): CountRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const MandatesRequestBuilderUriTemplate = "{+baseurl}/contracts/mandates";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const MandatesRequestBuilderNavigationMetadata: Record<Exclude<keyof MandatesRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    count: {
        requestsMetadata: CountRequestBuilderRequestsMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
